const mq = window.matchMedia('(min-width: 992px)');

Vue.component('cell', {
    props: {
        align: {
            type: String,
            default: 'text-xs-left'
        },
    },
    template: '<td class="ma0 pa0"><slot></slot></td>'
});

Vue.component('row', {
    template: '<tr><slot></slot></tr>'
});

if (typeof VeeValidate != 'undefined' && VeeValidate) {
    Vue.use(VeeValidate);
}

var vuetify = null;

if (typeof Vuetify != 'undefined' && Vuetify) {

    vuetify = new Vuetify({
        dataIterator: {
            noResultsText: "",
            loadingText: ""
        },
        theme: {
            themes: {
                light: {
                    primary: '#2870af',
                    secondary: '#04BF10',
                    accent: '#F27405',
                    error: '#F23005',
                    warning: '#ff9800',
                    info: '#BF784E',
                    success: '#04BF10'
                },
                dark: {
                    primary: '#7bbedb',
                    secondary: '#04BF10',
                    accent: '#F27405',
                    error: '#F23005',
                    warning: '#ff9800',
                    info: '#BF784E',
                    success: '#04BF10'
                },
            },
        },
    });

    Vue.use(vuetify);
}

const app = new Vue({
    vuetify: vuetify,
    data: {
        justAddedToCart: false,
        removeCouponTooltipOpen: false,
        removeShopCreditTooltipOpen: false,
        selectShopCreditTooltipOpen: false,
        removeGiftCertificateTooltipOpen: false,
        removeDownpaymentTooltipOpen: false,
        removePromotionCodeTooltipOpen: false,
        selectDeliveryServiceTooltipOpen: false,
        removeUpgradeShipmentMethodTooltipOpen: false,
        removeGiftCertificateViaPostTooltipOpen: false,
        isLoading: false,
        isMobile: !mq.matches,
        cart: [{
            cartInit: false,
            products: [],
            filteredProducts: [],
            anyTruckHi: false,
            anyTruckLo: false,
            totalProductCount: 0,
            anywarrantyActive: false,
            vat: [],
            vatExShipping: [],
            totalEco: '',
            totalVat: '',
            totalPrice: '',
            toPayPrice: '',
            toPayInclVATUnformatted: 0,
            oldTotalPrice: '',
            shipping: '',
            oldShipping: '',
            shopCredit: '',
            shopCreditCouponCodes: '',
            selectedShopCreditString: '',
            remainingShopCreditCouponCodes: '',
            giftCertificates: '',
            giftCertificateCouponCodes: '',
            selectedGiftCertificatesString: '',
            totalPriceExShipping: '',
            oldTotalPriceExShipping: '',
            hasPromotionCode: false,
            noStock: false,
            hasAllParcelService: true,
            hasAllGiftCertificates: false,
            hasAnyAssemblyRequired: false,
            hasAnyGiftCertificate: false,
            hasDeliveryService: false,
            hasDeliveryServicePlus: false,
            hasTruckService: false,
            hasWebShop: false,
            upgradeShipmentMethod: '',
            giftCertificateViaPost: false,
            upgradeShipmentMethodAllowed: false,
            createdMilliSeconds: 0,
            modifiedMilliSeconds: 0,
            maxFirstWeekAvailableText: '',
            maxFirstWeekAvailableTextComment: '',
            maxFirstWeekAvailable: 0,
            maxShowFirstWeekAvailable: false,
            downpaymentPercentage: 0,
            downpaymentAllowed: false,
            downPaymentPayToDriverUnformatted: 0,
            downPaymentPayToDriver: '',
            downPaymentPayNowUnformatted: 0,
            downPaymentPayNow: '',

            quantityOrderDiscountMarketingBlock: [],
            quantityItemDiscountMarketingBlock: [],
            itemDiscountMarketingBlock: [],
            orderDiscountMarketingBlock: [],
            freeShippingCostMarketingBlock: [],
            shippingCostDiscountMarketingBlock: [],
            couponMarketingBlock: [],
            upgradeShipmentMethodMarketingBlock: [],
            giftCertificateViaPostMarketingBlock: [],
            forcedUpgradeShipmentMethodMarketingBlock: [],
            staticMarketingBlock: [],
            validationIssues: []
        },
        {
            cartInit: false,
            products: [],
            filteredProducts: [],
            anyTruckHi: false,
            anyTruckLo: false,
            totalProductCount: 0,
            anywarrantyActive: false,
            vat: [],
            vatExShipping: [],
            totalEco: '',
            totalVat: '',
            totalPrice: '',
            toPayPrice: '',
            toPayInclVATUnformatted: 0,
            oldTotalPrice: '',
            shipping: '',
            oldShipping: '',
            shopCredit: '',
            shopCreditCouponCodes: '',
            selectedShopCreditString: '',
            remainingShopCreditCouponCodes: '',
            giftCertificates: '',
            giftCertificateCouponCodes: '',
            selectedGiftCertificatesString: '',
            totalPriceExShipping: '',
            oldTotalPriceExShipping: '',
            hasPromotionCode: false,
            noStock: false,
            hasAllParcelService: true,
            hasAllGiftCertificates: false,
            hasAnyAssemblyRequired: false,
            hasAnyGiftCertificate: false,
            hasDeliveryService: false,
            hasDeliveryServicePlus: false,
            hasTruckService: false,
            hasWebShop: false,
            upgradeShipmentMethod: '',
            giftCertificateViaPost: false,
            upgradeShipmentMethodAllowed: false,
            createdMilliSeconds: 0,
            modifiedMilliSeconds: 0,
            maxFirstWeekAvailableText: '',
            maxFirstWeekAvailableTextComment: '',
            maxFirstWeekAvailable: 0,
            maxShowFirstWeekAvailable: false,
            downpaymentPercentage: 0,
            downpaymentAllowed: false,
            downPaymentPayToDriverUnformatted: 0,
            downPaymentPayToDriver: '',
            downPaymentPayNowUnformatted: 0,
            downPaymentPayNow: '',

            quantityOrderDiscountMarketingBlock: [],
            quantityItemDiscountMarketingBlock: [],
            itemDiscountMarketingBlock: [],
            orderDiscountMarketingBlock: [],
            freeShippingCostMarketingBlock: [],
            shippingCostDiscountMarketingBlock: [],
            couponMarketingBlock: [],
            upgradeShipmentMethodMarketingBlock: [],
            giftCertificateViaPostMarketingBlock: [],
            forcedUpgradeShipmentMethodMarketingBlock: [],
            staticMarketingBlock: [],
            validationIssues: []
        }
        ],
        showCartAccount: false,
        showCartEmail: false,
        showCartSaved: false,
        cartLoginErrorMessage: '',
        cartAccountErrorMessage: '',
        searchOpen: false,
        searchTerm: '',
        autocompleteOpen: false,
        autocompleteSuggestions: [],
        searchAutocompleteIndex: -1,

        newsletterSubscribeSuccess: null,
        newsletterSubscribeFeedback: '',
        newsletterSuccessMessage: '',

        lookbookNewsletterSignup: false,

        heroVideoPlaying: false,
        heroVideoMobilePlaying: false,

        countryCode: document.documentElement.lang,

        windowhasscrollbar: false,

        loggedIn: website.loggedIn,
        loggedInCaption: website.loggedInCaption,
        loggedInMobileCaption: website.loggedInMobileCaption,

        cartindex: website.cartindex,

        shoppingCartWarningTime: website.shoppingCartWarningTime,
        favoritesWarningTime: website.favoritesWarningTime,

        extranetPage: 0,
        activeFlowboxTag: '',

        notificationPopupCode: '',
        notificationPopupName: '',
        zoomButtonPressed: false
    },
    mounted() {
        this.loggedIn = website.loggedIn;
        this.loggedInCaption = website.loggedInCaption;
        this.loggedInMobileCaption = website.loggedInMobileCaption;

        if (typeof gridLayout !== 'undefined') {
            gridLayout.create();
        }
        if (typeof productFilters !== 'undefined') {
            productFilters.initialize(true, true, this);
        }
        if (typeof storeOutletProductFilters !== 'undefined') {
            storeOutletProductFilters.initialize(true, true, this);
        }
        if (typeof configuratorFilters !== 'undefined') {
            configuratorFilters.initialize(true, true, this);
        }
        if (typeof myXooon !== 'undefined') {
            myXooon.initialize();
        }

        Vue.nextTick(() => {

            let scriptElement = document.getElementById('cookie-consent-io-cookie-data-table');
            if (scriptElement !== null) {
                if (typeof window.cookieConsent === 'undefined') {
                    document.addEventListener('CookieConsentInitialize', function () {
                        let scriptElement3 = document.getElementById('cookie-consent-io-cookie-data-table');
                        scriptElement3.innerHTML = window.cookieConsent.getCookieTable().innerHTML;
                    });
                } else {
                    scriptElement.innerHTML = window.cookieConsent.getCookieTable().innerHTML;
                }
            }

            let scriptElement2 = document.getElementById('cookie-consent-io-cookie-data-info');
            if (scriptElement2 !== null) {
                if (typeof window.cookieConsent === 'undefined') {
                    document.addEventListener('CookieConsentInitialize', function () {
                        let scriptElement4 = document.getElementById('cookie-consent-io-cookie-data-info');
                        scriptElement4.innerHTML = window.cookieConsent.getCookieInformation().innerHTML;
                    });
                } else {
                    scriptElement2.innerHTML = window.cookieConsent.getCookieInformation().innerHTML;
                }
            }

            const mediaBlockViewerDivs = document.getElementsByClassName('media-block-Viewer');
            if (mediaBlockViewerDivs != null) {

                window.addEventListener('keyup', (keyevt) => {

                    if (document.body.style.overflow === "hidden" && keyevt.key === "Escape") {

                        Array.from(mediaBlockViewerDivs).forEach((modelViewerDiv) => {

                            if (modelViewerDiv.style.height !== "") {

                                document.body.style.overflow = "";

                                modelViewerDiv.style.width = "";
                                modelViewerDiv.style.height = "";
                                modelViewerDiv.style.position = "";
                                modelViewerDiv.style.backgroundColor = "";
                                modelViewerDiv.style.top = "";
                                modelViewerDiv.style.left = "";
                                modelViewerDiv.style.zIndex = "";

                            }

                        });

                    }
                });

                window.addEventListener('resize', (resizeevt) => {

                    if (document.body.style.overflow === "hidden") {

                        Array.from(mediaBlockViewerDivs).forEach((modelViewerDiv) => {

                            if (modelViewerDiv.style.height !== "") {

                                var fullHeight = window.innerHeight + "px";

                                modelViewerDiv.style.height = fullHeight;
                            }
                        });
                    }
                });

                Array.from(mediaBlockViewerDivs).forEach((modelViewerDiv) => {

                    const mv = modelViewerDiv.getElementsByTagName('model-viewer')[0];

                    mv.addEventListener('progress', (event) => {
                        const progressBar = event.target.querySelector('.glb-progress-bar');
                        const updatingBar = event.target.querySelector('.glb-update-bar');
                        if (event.detail.totalProgress === 0) {
                            progressBar.style.display = 'block';
                            updatingBar.style.width = '0%';
                        } else {
                            updatingBar.style.width = `${event.detail.totalProgress * 100}%`;

                            if (event.detail.totalProgress === 1) {
                                setTimeout(() => {
                                    progressBar.style.display = 'none';
                                }, 500);
                            }
                        }
                    });

                    mv.addEventListener('load', (event) => {

                        const m = event.target;

                        m.addEventListener('camera-change', (ev) => {

                            const mm = ev.target;

                            app.renderModelViewerSVG(mm, mm.hasAttribute('show-dimensions'));

                            if (!this.zoomButtonPressed) {
                                mm.removeAttribute("auto-rotate");
                            } else {
                                setTimeout(() => {
                                    this.zoomButtonPressed = false;
                                }, 100);
                            }

                        });

                        let h = m.getAttribute("data-h");
                        let d = m.getAttribute("data-d");
                        let w = m.getAttribute("data-w");

                        app.setModelViewerHotspot(m, h, d, w);

                        app.renderModelViewerSVG(m, m.hasAttribute('show-dimensions'));
                    });
                });

            }

            let oPaging = document.querySelector('.js-search-paging');
            let oPagingButtons;

            if (oPaging !== null) {
                oPagingButtons = oPaging.querySelectorAll('.js-pagination-movepage');
            }

            if (typeof oPagingButtons !== 'undefined') {
                for (let i = 0; i < oPagingButtons.length; i += 1) {
                    oPagingButtons[i].addEventListener('click', (e) => {
                        const newPage = e.target.getAttribute('data-page');

                        const currentquery = e.target.getAttribute('data-search');
                        const currentSort = e.target.getAttribute('data-sort') || '';

                        const urlParams = new URLSearchParams(window.location.search);
                        //const currentquery = urlParams.get('search');
                        //const currentSort = urlParams.get('sort') || '';

                        window.location.href = '//' + window.location.host + window.location.pathname + "?search=" + currentquery + "&page=" + newPage + "&sort=" + currentSort;
                    });
                }
            }



        });

        if (typeof this.$refs.searchPageinput !== 'undefined') {
            this.searchTerm = this.$refs.searchPageinput.getAttribute('value');
        }

        if (localStorage.getItem('newsletterSubscribeSuccess') !== null) {
            this.newsletterSubscribeSuccess = JSON.parse(localStorage.getItem('newsletterSubscribeSuccess'));
            this.newsletterSubscribeFeedback = localStorage.getItem('newsletterSubscribeFeedback');
            this.newsletterSuccessMessage = localStorage.getItem('newsletterSuccessMessage');

            localStorage.removeItem('newsletterSubscribeSuccess');
            localStorage.removeItem('newsletterSubscribeFeedback');
            localStorage.removeItem('newsletterSuccessMessage');
        }

        if (this.$refs.heroVideo && !this.isMobile) {
            this.heroVideoPlaying = true;
        }

        if (this.$refs.heroVideoMobile && this.isMobile) {
            this.heroVideoMobilePlaying = true;
        }

        if (mq.addEventListener) {
            mq.addEventListener('change', this.handleViewportChange);
        } else {
            mq.addListener(this.handleViewportChange);
        }

        this.getCart(0);

        this.getCart(1);

        this.getLoggedInUser();

        this.handleCrossSellProductsSlider();

        this.handleInspirationSlider();

        this.handleAvailableElementsSlider();
    },
    computed: {
        isPortrait() {
            return (window.innerHeight > window.innerWidth);
        },
        productDescription: () => app.cart[0].products
            .filter(function (product) { return product.articleCode.indexOf('10350GP') === -1 })
            .map((item) => {
                if (typeof item.configurationString !== 'undefined' && item.configurationString !== '') {
                    return `${item.fullProductName} - ${item.configurationString}`;
                }
                return item.fullProductName;
            }),

        productDescription1: () => app.cart[1].products
            .filter(function (product) { return product.articleCode.indexOf('10350GP') === -1 })
            .map((item) => {
                if (typeof item.configurationString !== 'undefined' && item.configurationString !== '') {
                    return `${item.fullProductName} - ${item.configurationString}`;
                }
                return item.fullProductName;
            }),
        country() {
            let country;
            switch (this.countryCode) {
                case 'nl':
                case 'en-NL':
                    country = 'The Netherlands';
                    break;
                case 'nl-BE':
                case 'fr-BE':
                case 'de-BE':
                    country = 'Belgium';
                    break;
                case 'en-GB':
                    country = 'United-Kingdom';
                    break;
                case 'en-IE':
                    country = 'Ireland';
                    break;
                case 'de':
                    country = 'Germany';
                    break;
                case 'fr':
                    country = 'France';
                    break;
                case 'fr-LU':
                case 'de-LU':
                    country = 'Luxembourg';
                    break;
                case 'de-AT':
                    country = 'Austria';
                    break;
                case 'de-CH':
                case 'fr-CH':
                    country = 'Switzerland';
                    break;
                default:
                    return this.countryCode;
            }

            return country;
        },
    },
    watch: {
        searchOpen(open) {
            if (typeof app.$refs.searchinput === 'undefined') {
                Vue.nextTick(() => {
                    if (open) {
                        app.$refs.searchinput.focus();
                    }
                });
            } else if (open) {
                app.$refs.searchinput.focus();
            }
        },
    },
    filters: {
        decodeHtml: (html) => {
            const txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value;
        },
    },
    created: function () {

        if (typeof VeeValidate != 'undefined' && VeeValidate) {

            VeeValidate.Validator.locale = this.countryCode.split('-')[0];
            VeeValidate.Validator.localize(VeeValidate.Validator.locale);
        }

        window.addEventListener('resize', evt => this.checkScrollbar());
    },
    destroyed: function () {

        window.removeEventListener('resize', evt => this.checkScrollbar());
    },
    methods: {
        openFavoriteListEvent: () => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'favorietenlijst_bekijken'
            });
        },
        printWishlistEvent: () => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'print_wishlist'
            });
        },
        saveWishlistEvent: () => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'save_wishlist'
            });
        },
        changeCollectionClass: (collection) => {

            if (collection.toLowerCase() === "coco maison") {
                return "productdetail__card__title--lower"
            }
            else {
                return ""
            }

        },

        changeCollection: (collection) => {

            if (collection.toLowerCase() === "coco maison") {
                return "COCO&ZeroWidthSpace;maison"
            }
            else {
                return collection
            }

        },

        refreshCart: (index = 0) => {

            app.getCart(index);

        },

        handleInspirationSlider() {

            var inspirationsliderdetails = document.querySelector('#inspirationsliderdetails');

            if (inspirationsliderdetails != null) {

                var hashtagfilter = inspirationsliderdetails.getAttribute('data-hashtagfilter');

                fetch(encodeURI(`/InspirationSlider/InspirationSliderAjax/?hashTagFilter=${hashtagfilter}`), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                }).then(response => response.text()).then((response) => {

                    inspirationsliderdetails.innerHTML = response;

                    inspirationsliderdetails.classList.add("js-slider");

                    fSliders();
                });

            }
        },

        handleAvailableElementsSlider() {

            var availableelementssliderdetails = document.querySelector('#availableelementsdetails');

            if (availableelementssliderdetails != null) {

                var code = availableelementssliderdetails.getAttribute('data-code');

                fetch(encodeURI(`/AvailableElementsSlider/AvailableElementsSliderAjax/?code=${code}`), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                }).then(response => response.text()).then((response) => {

                    availableelementssliderdetails.innerHTML = response;

                    availableelementssliderdetails.classList.add("js-slider");

                    fSliders();
                });

            }
        },

        handleCrossSellProductsSlider() {

            var crosssellproductssliderdetails = document.querySelector('#crosssellproductsdetails');

            if (crosssellproductssliderdetails != null) {

                var code = crosssellproductssliderdetails.getAttribute('data-code');

                fetch(encodeURI(`/CrossSellProductsSlider/CrossSellProductsSliderAjax/?code=${code}`), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                }).then(response => response.text()).then((response) => {

                    crosssellproductssliderdetails.innerHTML = response;

                    crosssellproductssliderdetails.classList.add("js-slider");

                    fSliders();
                });

            }
        },

        influxDbEvent(event) {

            fetch('/api/cart/influxdbevent',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        Event: event
                    })
                }).then((response) => {
                });

        },
        help3d() {

            const myModal = new Modal(document.querySelector('.modal--help3d'));

            myModal.open();
        },

        setModelViewerVisibility(modelViewer, element, showDimensions) {
            if (showDimensions) {
                modelViewer.removeAttribute("auto-rotate");
                element.classList.remove('modelViewer-Hide');
            } else {
                element.classList.add('modelViewer-Hide');
            }

            this.renderModelViewerSVG(modelViewer, showDimensions);
        },

        setModelViewerHotspot(m, h, d, w) {
            const center = m.getBoundingBoxCenter();
            const size = m.getDimensions();
            const x2 = size.x / 2;
            const y2 = size.y / 2;
            const z2 = size.z / 2;

            m.updateHotspot({
                name: 'hotspot-dot+X-Y+Z',
                position: `${center.x + x2} ${center.y - y2} ${center.z + z2}`
            });

            m.updateHotspot({
                name: 'hotspot-dim+X-Y',
                position: `${center.x + (x2 * 1.2)} ${center.y - (y2 * 1.1)} ${center.z}`
            });

            //let h = asset.h; // size.y
            //let d = asset.d; // size.z
            //let w = asset.w; // size.x

            if (w !== "" && d !== "") {

                var wnum = w.substring(0, w.indexOf(' '));
                var secondw = w.indexOf('-');
                if (secondw >= 0) {
                    var wss = w.substring(secondw + 2);
                    wnum = wss.substring(0, wss.indexOf(' '));
                }

                var dnum = d.substring(0, d.indexOf(' '));
                var secondd = d.indexOf('-');
                if (secondd >= 0) {
                    var dss = d.substring(secondd + 2);
                    dnum = dss.substring(0, dss.indexOf(' '));
                }

                if (size.x > size.z) {
                    if (Number(wnum) < Number(dnum)) {
                        let t1 = w;
                        w = d;
                        d = t1;
                    }
                } else if (size.x < size.z) {
                    if (Number(wnum) > Number(dnum)) {
                        let t2 = w;
                        w = d;
                        d = t2;
                    }
                }
            }

            if (h === "") {
                h = `${(size.y * 100).toFixed(0)} cm`;
            }

            if (d === "") {
                d = `${(size.z * 100).toFixed(0)} cm`;
            }

            if (w === "") {
                w = `${(size.x * 100).toFixed(0)} cm`;
            }

            h = h.replaceAll(' cm', '&nbsp;cm');
            w = w.replaceAll(' cm', '&nbsp;cm');
            d = d.replaceAll(' cm', '&nbsp;cm');

            m.querySelector('button[slot="hotspot-dim+X-Y"]').innerHTML = d;
            //`${(size.z * 100).toFixed(0)} cm`;

            m.updateHotspot({
                name: 'hotspot-dot+X-Y-Z',
                position: `${center.x + x2} ${center.y - y2} ${center.z - z2}`
            });

            m.updateHotspot({
                name: 'hotspot-dim+X-Z',
                position: `${center.x + (x2 * 1.2)} ${center.y} ${center.z - (z2 * 1.2)}`
            });
            m.querySelector('button[slot="hotspot-dim+X-Z"]').innerHTML = h;
            //`${(size.y * 100).toFixed(0)} cm`;

            m.updateHotspot({
                name: 'hotspot-dot+X+Y-Z',
                position: `${center.x + x2} ${center.y + y2} ${center.z - z2}`
            });

            m.updateHotspot({
                name: 'hotspot-dim+Y-Z',
                position: `${center.x} ${center.y + (y2 * 1.1)} ${center.z - (z2 * 1.1)}`
            });
            m.querySelector('button[slot="hotspot-dim+Y-Z"]').innerHTML = w;
            //`${(size.x * 100).toFixed(0)} cm`;

            m.updateHotspot({
                name: 'hotspot-dot-X+Y-Z',
                position: `${center.x - x2} ${center.y + y2} ${center.z - z2}`
            });

            m.updateHotspot({
                name: 'hotspot-dim-X-Z',
                position: `${center.x - (x2 * 1.2)} ${center.y} ${center.z - (z2 * 1.2)}`
            });
            m.querySelector('button[slot="hotspot-dim-X-Z"]').innerHTML = h;
            //`${(size.y * 100).toFixed(0)} cm`;

            m.updateHotspot({
                name: 'hotspot-dot-X-Y-Z',
                position: `${center.x - x2} ${center.y - y2} ${center.z - z2}`
            });

            m.updateHotspot({
                name: 'hotspot-dim-X-Y',
                position: `${center.x - (x2 * 1.2)} ${center.y - (y2 * 1.1)} ${center.z}`
            });
            m.querySelector('button[slot="hotspot-dim-X-Y"]').innerHTML = d;
            //`${(size.z * 100).toFixed(0)} cm`;

            m.updateHotspot({
                name: 'hotspot-dot-X-Y+Z',
                position: `${center.x - x2} ${center.y - y2} ${center.z + z2}`
            });

        },

        drawModelViewerLine(showDimensions, svgLine, dotHotspot1, dotHotspot2, dimensionHotspot) {
            if (dotHotspot1 && dotHotspot2) {
                svgLine.setAttribute('x1', dotHotspot1.canvasPosition.x);
                svgLine.setAttribute('y1', dotHotspot1.canvasPosition.y);
                svgLine.setAttribute('x2', dotHotspot2.canvasPosition.x);
                svgLine.setAttribute('y2', dotHotspot2.canvasPosition.y);

                // use provided optional hotspot to tie visibility of this svg line to
                if (!showDimensions || (dimensionHotspot && !dimensionHotspot.facingCamera)) {
                    svgLine.classList.add('modelViewer-Hide');
                }
                else {
                    svgLine.classList.remove('modelViewer-Hide');
                }
            }
        },

        renderModelViewerSVG(modelViewer, showDimensions) {

            const dimLines = modelViewer.querySelectorAll('line');

            this.drawModelViewerLine(showDimensions, dimLines[0], modelViewer.queryHotspot('hotspot-dot+X-Y+Z'), modelViewer.queryHotspot('hotspot-dot+X-Y-Z'), modelViewer.queryHotspot('hotspot-dim+X-Y'));
            this.drawModelViewerLine(showDimensions, dimLines[1], modelViewer.queryHotspot('hotspot-dot+X-Y-Z'), modelViewer.queryHotspot('hotspot-dot+X+Y-Z'), modelViewer.queryHotspot('hotspot-dim+X-Z'));
            this.drawModelViewerLine(showDimensions, dimLines[2], modelViewer.queryHotspot('hotspot-dot+X+Y-Z'), modelViewer.queryHotspot('hotspot-dot-X+Y-Z'), modelViewer.queryHotspot('hotspot-dot-X+Y-Z')); // was always visible before
            this.drawModelViewerLine(showDimensions, dimLines[3], modelViewer.queryHotspot('hotspot-dot-X+Y-Z'), modelViewer.queryHotspot('hotspot-dot-X-Y-Z'), modelViewer.queryHotspot('hotspot-dim-X-Z'));
            this.drawModelViewerLine(showDimensions, dimLines[4], modelViewer.queryHotspot('hotspot-dot-X-Y-Z'), modelViewer.queryHotspot('hotspot-dot-X-Y+Z'), modelViewer.queryHotspot('hotspot-dim-X-Y'));
        },

        modelViewerDimensions(evt) {

            var modelViewer = evt.target.closest('model-viewer');

            let showModelViewerDimensions = modelViewer.hasAttribute('show-dimensions');

            showModelViewerDimensions = !showModelViewerDimensions;

            if (!showModelViewerDimensions) {
                modelViewer.removeAttribute('show-dimensions');
            } else {
                modelViewer.setAttribute('show-dimensions', 'true');
            }

            if (showModelViewerDimensions) {
                modelViewer.resetTurntableRotation(0);
                modelViewer.setAttribute("camera-orbit", "45deg 75deg 114%");
            }

            setTimeout(() => {
                app.setModelViewerVisibility(modelViewer, modelViewer.querySelector('#dimlines'), showModelViewerDimensions);
                modelViewer.querySelectorAll('button').forEach((hotspot) => {
                    app.setModelViewerVisibility(modelViewer, hotspot, showModelViewerDimensions);
                });
            }, 100);

        },

        modelViewerZoom(evt) {

            this.zoomButtonPressed = true;

            var modelViewer = evt.target.closest('model-viewer');

            var modelViewerDiv = modelViewer.closest('div');

            let useElem = evt.target
                .closest('div')
                .getElementsByTagName('use')[0];

            if (modelViewerDiv.style.height !== "") {

                useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomin');

                document.body.style.overflow = "";

                modelViewerDiv.style.width = "";
                modelViewerDiv.style.height = "";
                modelViewerDiv.style.position = "";
                modelViewerDiv.style.backgroundColor = "";
                modelViewerDiv.style.top = "";
                modelViewerDiv.style.left = "";
                modelViewerDiv.style.zIndex = "";

            } else {

                useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomout');

                document.body.style.overflow = "hidden";

                var fullHeight = window.innerHeight + "px";

                modelViewerDiv.style.width = "100vw";
                modelViewerDiv.style.height = fullHeight;
                modelViewerDiv.style.position = "fixed";
                modelViewerDiv.style.backgroundColor = "#ffffff";
                modelViewerDiv.style.top = "0";
                modelViewerDiv.style.left = "0";
                modelViewerDiv.style.zIndex = "50";
            }

        },

        selectedStoreHelp() {

            const myModal = new Modal(document.querySelector('.modal--selectedstore'));

            myModal.open();
        },

        warrantyHelp() {

            const myModal = new Modal(document.querySelector('.modal--warranty'));

            myModal.open();
        },

        overviewFilter() {

            const myModal = new Modal(document.querySelector('.modal--overviewfilter'));

            myModal.open();
        },

        truckpremiumpaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--truckpremiumpayment'));

            myModal.open();
        },

        truckpremiumpluspaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--truckpremiumpluspayment'));

            myModal.open();
        },

        truckpaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--truckpayment'));

            myModal.open();
        },

        truckhipaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--truckhipayment'));

            myModal.open();
        },

        parcelservicepaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--parcelservicepayment'));

            myModal.open();
        },

        onlinepaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--onlinepayment'));

            myModal.open();
        },

        letterpaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--letterpayment'));

            myModal.open();
        },

        downpaymentHelp() {

            const myModal = new Modal(document.querySelector('.modal--downpayment'));

            myModal.open();
        },

        warrantyClick(product, index = 0) {

            if (!product.warrantyActive) {
                product.totalCalculatedWarrantyPrice = product.totalWarrantyPrice;
            }

            product.warrantyActive = !product.warrantyActive;

            fetch('/api/cart/addorupdatewarranty',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        Code: product.code,
                        WarrantyPrice: product.warrantyPrice,
                        WarrantyActive: product.warrantyActive,
                        Index: index
                    }),
                }).then(response => response.json()).then((cartData) => {
                    app.assignCartData(cartData, index);
                });

        },
        openAccountDropdown() {

            const myModal = new Modal(document.querySelector('.modal--accountdropdown'));

            myModal.open();

        },

        removeUpgradeShipmentMethod: (index = 0) => {

            app.hideAllTooltips();

            fetch('/api/cart/removeupgradeshipmentmethod', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    Index: index
                })

            }).then(response => response.json()).then((cartData) => {
                app.assignCartData(cartData, index);
            });
        },

        hideAllTooltips: () => {
            app.removeUpgradeShipmentMethodTooltipOpen = false;
            app.removeGiftCertificateTooltipOpen = false;
            app.removeGiftCertificateViaPostTooltipOpen = false;
            app.removeCouponTooltipOpen = false;
            app.removeShopCreditTooltipOpen = false;
            app.selectShopCreditTooltipOpen = false;
            app.removeDownpaymentTooltipOpen = false;
            app.removePromotionCodeTooltipOpen = false;
            app.selectDeliveryServiceTooltipOpen = false;
        },

        toggleRemoveUpgradeShipmentMethodTooltip: () => {

            if (app.removeUpgradeShipmentMethodTooltipOpen) {
                app.removeUpgradeShipmentMethodTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.removeUpgradeShipmentMethodTooltipOpen = true;
            }
        },

        removeGiftCertificateViaPost: (index = 0) => {

            app.hideAllTooltips();

            fetch('/api/cart/removegiftcertificateviapost', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    Index: index
                })

            }).then(response => response.json()).then((cartData) => {
                app.assignCartData(cartData, index);
            });
        },

        toggleRemoveGiftCertificateViaPostTooltip: () => {

            if (app.removeGiftCertificateViaPostTooltipOpen) {
                app.removeGiftCertificateViaPostTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.removeGiftCertificateViaPostTooltipOpen = true;
            }
        },

        removePromotionCodeFromCart: (code, index = 0) => {
            app.removePromotionCodeTooltipOpen = false;

            fetch('/api/cart/removePromotionCode',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        Code: code,
                        Index: index
                    })
                }).then(response => response.json()).then((cartData) => {
                    app.assignCartData(cartData, index);
            });

        },
        removeCouponFromCart: (index = 0) => {

            app.hideAllTooltips();

            fetch('/api/cart/removeCoupon',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        Index: index
                    })

                }).then(response => response.json()).then((cartData) => {
                    app.assignCartData(cartData, index);
            });

        },
        toggleRemoveCouponTooltip: () => {

            if (app.removeCouponTooltipOpen) {
                app.removeCouponTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.removeCouponTooltipOpen = true;
            }
        },

        toggleRemoveShopCreditTooltip: () => {

            if (app.removeShopCreditTooltipOpen) {
                app.removeShopCreditTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.removeShopCreditTooltipOpen = true;
            }
        },

        toggleSelectShopCreditTooltip: () => {

            if (app.selectShopCreditTooltipOpen) {
                app.selectShopCreditTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.selectShopCreditTooltipOpen = true;
            }
        },

        toggleRemoveGiftCertificateTooltip: () => {

            if (app.removeGiftCertificateTooltipOpen) {
                app.removeGiftCertificateTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.removeGiftCertificateTooltipOpen = true;
            }
        },

        toggleRemoveDownpaymentTooltip: () => {

            if (app.removeDownpaymentTooltipOpen) {
                app.removeDownpaymentTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.removeDownpaymentTooltipOpen = true;
            }
        },


        toggleRemovePromotionCodeTooltip: () => {

            if (app.removePromotionCodeTooltipOpen) {
                app.removePromotionCodeTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.removePromotionCodeTooltipOpen = true;
            }
        },

        toggleSelectDeliveryServiceTooltip: () => {

            if (app.selectDeliveryServiceTooltipOpen) {
                app.selectDeliveryServiceTooltipOpen = false;
            } else {
                app.hideAllTooltips();
                app.selectDeliveryServiceTooltipOpen = true;
            }
        },

        checkScrollbar() {
            this.windowhasscrollbar = document.documentElement.scrollHeight > document.documentElement.offsetHeight ||
                document.body.scrollHeight > document.body.offsetHeight;
        },

        toggleroomplanner() {

            this.justAddedToCart = false;

            var iframe = document.getElementById('iframeWebGL');

            if (iframe != null) {

                var receipt = document.getElementById('roomplannerreceipt');

                var details = document.getElementById('projectnumberdetails');

                if (receipt != null) {

                    if (iframe.style.display === "none") {
                        iframe.style.display = "block";
                        receipt.style.display = "none";
                        
                        if (details != null) {
                            details.style.display = "none";
                        }

                    } else {
                        iframe.style.display = "none";
                        receipt.style.display = "block";

                        if (details != null) {
                            details.style.display = "none";
                        }
                    }

                    var backdetailsbutton = document.getElementById('backdetailsbutton');

                    var receiptbackbutton = document.getElementById('receiptbackbutton');
                    if (receiptbackbutton != null) {
                        if (receiptbackbutton.style.display === "none") {
                            receiptbackbutton.style.display = "inline-block";
                            if (backdetailsbutton != null) {
                                backdetailsbutton.style.display = "none";
                            }
                        } else {
                            receiptbackbutton.style.display = "none";
                        }
                    }

                    var receiptbutton = document.getElementById('receiptbutton');
                    if (receiptbutton != null) {

                        if (details != null && details.style.display !== "none") {

                            receiptbutton.style.display = "none";

                        } else {

                            if (this.$refs.configurator3ddetailref != null) {

                                if (this.$refs.configurator3ddetailref.configurator3d != null) {

                                    if (receiptbutton.style.display === "none") {
                                        receiptbutton.style.visibility = "visible";
                                        receiptbutton.style.display = "inline-block";
                                        if (backdetailsbutton != null) {
                                            backdetailsbutton.style.display = "inline-block";
                                        }
                                    } else {
                                        receiptbutton.style.display = "none";
                                    }
                                }

                            } else {

                                if (receiptbutton.style.display === "none") {
                                    receiptbutton.style.visibility = "visible";
                                    receiptbutton.style.display = "inline-block";
                                    if (backdetailsbutton != null) {
                                        backdetailsbutton.style.display = "inline-block";
                                    }
                                } else {
                                    receiptbutton.style.display = "none";
                                }

                            }
                        }
                    }

                }
            }

            this.checkScrollbar();

        },

        toggleprojectnumberdetail() {

            this.justAddedToCart = false;

            if (typeof this.$refs.projectnumbersref !== 'undefined') {
                this.$refs.projectnumbersref.fetchData();
            }

            var iframe = document.getElementById('iframeWebGL');

            if (iframe != null) {

                var receipt = document.getElementById('roomplannerreceipt');

                var details = document.getElementById('projectnumberdetails');

                if (details != null) {

                    if (details.style.display === "none") {

                        iframe.style.display = "none";
                        details.style.display = "block";
                        receipt.style.display = "none";

                    } else {

                        iframe.style.display = "block";
                        details.style.display = "none";
                        receipt.style.display = "none";
                    }

                    var backdetailsbutton = document.getElementById('backdetailsbutton');

                    var receiptbackbutton = document.getElementById('receiptbackbutton');
                    if (receiptbackbutton != null) {
                        if (iframe.style.display === "none") {
                            receiptbackbutton.style.display = "inline-block";
                        } else {
                            receiptbackbutton.style.display = "none";
                        }
                    }

                    var receiptbutton = document.getElementById('receiptbutton');
                    if (receiptbutton != null) {

                        if (details != null && details.style.display !== "none") {

                            receiptbutton.style.display = "none";

                        } else {

                            if (this.$refs.configurator3ddetailref != null) {

                                if (this.$refs.configurator3ddetailref.configurator3d != null) {

                                    if (receiptbutton.style.display === "none") {
                                        receiptbutton.style.visibility = "visible";
                                        receiptbutton.style.display = "inline-block";
                                        if (backdetailsbutton != null) {
                                            backdetailsbutton.style.display = "inline-block";
                                        }
                                    } else {
                                        receiptbutton.style.display = "none";
                                    }
                                }

                            } else {

                                if (receiptbutton.style.display === "none") {
                                    receiptbutton.style.visibility = "visible";
                                    receiptbutton.style.display = "inline-block";
                                    if (backdetailsbutton != null) {
                                        backdetailsbutton.style.display = "inline-block";
                                    }
                                } else {
                                    receiptbutton.style.display = "none";
                                }

                            }
                        }
                    }

                }
            }

            this.checkScrollbar();

        },

    getLoggedInUser: () => {
        fetch('/api/loggedinuser', {
          headers: {
              'Accept-Language': document.documentElement.lang,
              'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
      }).then(response => response.json()).then((loggedInUserData) => {

          app.loggedIn = loggedInUserData.loggedIn;
          app.loggedInCaption = loggedInUserData.loggedInCaption;
          app.loggedInMobileCaption = loggedInUserData.loggedInMobileCaption;

          var accountOverviewTitleTop = document.getElementById("AccountOverviewTitleTop");
          if (accountOverviewTitleTop != null) {
              accountOverviewTitleTop.innerHTML = app.loggedInCaption;
          }
          var accountOverviewTitleSidebar = document.getElementById("AccountOverviewTitleSidebar");
          if (accountOverviewTitleSidebar != null) {
              accountOverviewTitleSidebar.innerHTML = app.loggedInCaption;
          }
          var accountOverviewTitleMobile = document.getElementById("AccountOverviewTitleMobile");
          if (accountOverviewTitleMobile != null) {
              accountOverviewTitleMobile.innerHTML = app.loggedInMobileCaption;
          }

      });
    },

    getCart: (index = 0) => {
        fetch(`/api/cart?index=${index}`, {        
        cache: "no-store",
        headers: {
            'Accept-Language': document.documentElement.lang,
            'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        }).then(response => response.json()).then((cartData) => {
          app.assignCartData(cartData, index);
      });
    },
    addOrUpdateCart: (code, displayname, quantity, lowestPrice, lowestOldPrice, ecoTax, assemblyCost, actionTotalAmount, actionFreeAmount, configuration, byQuantity = false, input = null,
        configurationString = null, redirectUrl = null, index = 0, viewItem = null, partsList = null, priceCode = null) => {
      let color = null;
      let prodtype = null;
      let assemblyRequired = null;
      let truckHi = null;
      let parcelService = null;

      if (input !== null) {
        input.disabled = true;
      }

      if (app.$refs.productdetailNonConfigurable && !byQuantity) {
        code = app.$refs.productdetailNonConfigurable.selectedVariant.code;
        color = app.$refs.productdetailNonConfigurable.selectedVariant.displayName;

        if (app.$refs.productdetailNonConfigurable.selectedVariant.prodType) {
            prodtype = app.$refs.productdetailNonConfigurable.selectedVariant.prodType.toLowerCase();
        }

        if (app.$refs.productdetailNonConfigurable.selectedVariant.assemblyRequired != null) {
            assemblyRequired = app.$refs.productdetailNonConfigurable.selectedVariant.assemblyRequired;
        }

        if (app.$refs.productdetailNonConfigurable.selectedVariant.truckHi != null) {
            truckHi = app.$refs.productdetailNonConfigurable.selectedVariant.truckHi;
        }

        if (app.$refs.productdetailNonConfigurable.selectedVariant.parcelService != null) {
            parcelService = app.$refs.productdetailNonConfigurable.selectedVariant.parcelService;
        }

        if (color === displayname && app.$refs.productdetailNonConfigurable.selectedVariant.color) {
          color = app.$refs.productdetailNonConfigurable.selectedVariant.color.toLowerCase();
        }

        actionTotalAmount = app.$refs.productdetailNonConfigurable.selectedVariant.actionTotalAmount;
        actionFreeAmount = app.$refs.productdetailNonConfigurable.selectedVariant.actionFreeAmount;
      }

      // Set configuration if on productDetail and configuration is complete
      if (app.$refs.productdetailConfigurable && app.$refs.productdetailConfigurable.configurator !== null) {
        if (app.$refs.productdetailConfigurable.configurator.completed && app.$refs.productdetailConfigurable.configuratorOpen) {
          configuration = app.$refs.productdetailConfigurable.configurator.currentConfigurationList;

          if (app.$refs.productdetailConfigurable.configurator.actionPrice > 0) {
            lowestOldPrice = app.$refs.productdetailConfigurable.configurator.consumerPriceNet + app.$refs.productdetailConfigurable.configurator.consumerTotalSurcharge;
          }

          lowestPrice = (app.$refs.productdetailConfigurable.configurator.actionPrice > 0
            ? app.$refs.productdetailConfigurable.configurator.actionPrice
            : app.$refs.productdetailConfigurable.configurator.consumerPriceNet + app.$refs.productdetailConfigurable.configurator.consumerTotalSurcharge);

          app.$refs.productdetailConfigurable.toggleConfigurator(false);
          window.scroll(0, 0);
        }
      }

      if (app.$refs.productdetailNonConfigurable && 
          app.$refs.productdetailNonConfigurable.selectedVariant != null &&
          app.$refs.productdetailNonConfigurable.selectedVariant.parts != null &&
          app.$refs.productdetailNonConfigurable.selectedVariant.parts.length > 0) {

        var selectedParts = [];

        var totalPriceAmount = 0;
        var totalOldPriceAmount = 0;
        var totalEcoTaxAmount = 0;

        app.$refs.productdetailNonConfigurable.selectedVariant.parts.forEach((part, i) => {
            if (part.selectedprodId && part.selectedprodId.length > 0) {
                selectedParts.push(part.selectedprodId);

                totalPriceAmount += part.selectedPriceAmount;
                totalOldPriceAmount += part.selectedOldPriceAmount;
                totalEcoTaxAmount += part.selectedEcoTaxAmount;
            }
        });

        totalPriceAmount += app.$refs.productdetailNonConfigurable.selectedVariant.priceAmount;
        totalOldPriceAmount += app.$refs.productdetailNonConfigurable.selectedVariant.oldPriceAmount;
        totalEcoTaxAmount += app.$refs.productdetailNonConfigurable.selectedVariant.ecoTaxAmount;

        lowestPrice = totalPriceAmount;
        lowestOldPrice = totalOldPriceAmount;
        ecoTax = totalEcoTaxAmount;

        if (selectedParts.length > 0) {
            partsList = selectedParts.join(',');
        }
      }

      fetch('/api/cart/addorupdate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': document.documentElement.lang,
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          Code: code,
          DisplayName: displayname,
          Color: color,
          ProdType: prodtype,
          AssemblyRequired: assemblyRequired,
          TruckHi: truckHi,
          ParcelService: parcelService,
          Quantity: quantity,
          Price: lowestPrice,
          OldPrice: lowestOldPrice,
          EcoTax: ecoTax,
          AssemblyCost: assemblyCost,
          ActionTotalAmount: actionTotalAmount,
          ActionFreeAmount: actionFreeAmount,
          Configuration: configuration,
          ConfigurationString: configurationString,
          ProjectNumber3d: '',
          Index: index,
          PartsList: partsList,
          PriceCode: priceCode
        }),
      }).then(response => response.json()).then((cartData) => {
          app.assignCartData(cartData, index);

          if (viewItem != null) {
              //console.log(viewItem);
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({ 'ecommerce': null });
              dataLayer.push({
                  'event': ((index === 0 && app.cart[index].hasWebShop === true) ? 'add_to_cart' : 'add_to_wishlist'),
                  'ecommerce': viewItem
              });

          }

          if (input !== null) {
            input.disabled = false;
          }

          if (redirectUrl !== null) {
            window.location.href = redirectUrl;
          }

      });
    },

    addOrUpdateCartAppointment: (code, displayname, quantity, lowestPrice, lowestOldPrice, ecoTax, assemblyCost, actionTotalAmount, actionFreeAmount, configuration, byQuantity = false, input = null,
        configurationString = null, redirectUrl = null, index = 0, viewItem = null, partsList = null, priceCode = null) => {
        //console.log(code);
        //console.log(redirectUrl);
        //!!!!!!!!!!!!!!!!!!!!

        app.addOrUpdateCart(code, displayname, quantity, lowestPrice, lowestOldPrice, ecoTax, assemblyCost, actionTotalAmount, actionFreeAmount, configuration, byQuantity, input,
            configurationString, redirectUrl, index, viewItem, partsList, priceCode);

        //!!!!!!!!!!!

        //if (redirectUrl !== null) {
        //    window.location.href = redirectUrl;
        //}

    },
    showNotificationPopup: (code, articleName, variantName) => {

        if (articleName !== variantName) {
            articleName += ' - ' + variantName;
        }

        app.notificationPopupCode = code;
        app.notificationPopupName = articleName;

        const stocknotificationModal = new Modal(document.querySelector('.js-stocknotification-modal'));

        stocknotificationModal.open();

        setTimeout(() => {
            document.getElementById("StockNotificationEmail").focus();
        },
            400);

    },

    showShoppingCartWarningPopup: () => {
        
        setTimeout(() => {

            var gm = document.querySelector('.js-shoppingcartwarning-modal');

            if (gm != null) {

                docCookies.setItem('openShoppingCartWarningPopup', Date.now(), 2629746, '/');

                const shoppingcartwarningModal = new Modal(gm);

                shoppingcartwarningModal.open();
            }
        }, 4000);

    },
    showFavoritesWarningPopup: () => {

        setTimeout(() => {

            var gm = document.querySelector('.js-favoriteswarning-modal');

            if (gm != null) {

                docCookies.setItem('openFavoritesWarningPopup', Date.now(), 2629746, '/');

                const favoriteswarningModal = new Modal(gm);

                favoriteswarningModal.open();
            }
        }, 4000);

    },


    clickShoppingCartWarningPopup: () => {

        setTimeout(() => { app.$refs.shoppinglistheaderbutton.click(); }, 600);
    },
    clickFavoritesWarningPopup: () => {

        setTimeout(() => { app.$refs.shoppinglistheaderbutton1.click(); }, 600);

    },

    addNotification: (confirmationText, errorText) => {

        var code = app.notificationPopupCode;
        var articleName = app.notificationPopupName;

        var form = document.getElementById('stocknotification-form');

        if (form.checkValidity()) {

            const stocknotificationModal = new Modal(document.querySelector('.js-stocknotification-modal'));

            stocknotificationModal.close();

            var stockNotificationEmail =
                document.getElementById('StockNotificationEmail');

            var stockNotificationFirstName =
                document.getElementById('StockNotificationFirstName');

            var stockNotificationNewsletter =
                document.getElementById('StockNotificationNewsletterSignup');

            if (stockNotificationNewsletter && stockNotificationNewsletter.checked) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'newsletter_submit',
                    'userdata': {
                        'email': stockNotificationEmail.value,
                        'address': {
                            'first_name': stockNotificationFirstName.value
                        }
                    }
                });
            }

            fetch(encodeURI(`/api/cart/checkemail/?email=${stockNotificationEmail.value}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
            }).then((response) => {
                if (response.status === 200) {

                    setTimeout(() => {
                        const stocknotificationconfirmationModal =
                            new Modal(document.querySelector('.js-stocknotificationconfirmation-modal'));


                        var stocknotificationconfirmationtext =
                            document.getElementById('stocknotificationconfirmationtext');

                        stocknotificationconfirmationtext.innerHTML = confirmationText.replace('{1}', stockNotificationEmail.value).replace('{0}', articleName);

                        stocknotificationconfirmationModal.open();

                    },
                        400);

                    fetch('/api/cart/addorupdatestocknotification', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': document.documentElement.lang,
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        credentials: 'same-origin',
                        body: JSON.stringify({
                            Code: code,
                            Email: stockNotificationEmail.value,
                            FirstName: stockNotificationFirstName.value,
                            Newsletter: stockNotificationNewsletter.checked ? "True" : "False"
                        }),
                    });

                } else {

                    setTimeout(() => {
                        const stocknotificationconfirmationModal =
                            new Modal(document.querySelector('.js-stocknotificationconfirmation-modal'));

                        var stocknotificationconfirmationtext =
                            document.getElementById('stocknotificationconfirmationtext');

                        stocknotificationconfirmationtext.innerHTML = errorText.replace('{email}', stockNotificationEmail.value);

                        stocknotificationconfirmationModal.open();

                    },
                        400);
                }
            })
        }
    },

    addShopCredit: (index = 0) => {

        app.hideAllTooltips();

        fetch('/api/cart/addshopcredit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Index: index
            })

        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, index);
        });
    },
    removeShopCredit: function (index = 0) {

        app.hideAllTooltips();

        var self = this;

        fetch('/api/cart/removeshopcredit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Index: index
            })

        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, index);

            //console.log('ccc');
            //window.location.reload();

            if (typeof self.$refs.placeOrderSummary !== 'undefined') {
                self.$refs.placeOrderSummary.reloadPayments();
            }

        });
    },

    removeGiftCertificates: function (index = 0) {

        app.hideAllTooltips();

        var self = this;

        fetch('/api/cart/removegiftcertificates', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Index: index
            })

        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, index);

            //console.log('ddd');
            //window.location.reload();

            if (typeof self.$refs.placeOrderSummary !== 'undefined') {
                self.$refs.placeOrderSummary.reloadPayments();
            }

        });
    },

    removeDownpayment: function (index = 0) {

        app.hideAllTooltips();

        var self = this;

        fetch('/api/cart/removedownpayment', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Index: index
            })

        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, index);

            //console.log('ddd');
            //window.location.reload();
        });
    },

    setGiftCertificateViaPost: ( index = 0) => {

        fetch('/api/cart/setgiftcertificateviapost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Index: index
            }),
        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, index);
        });
    },

    setDownpayment: (percentage, index = 0) => {

        fetch('/api/cart/setdownpayment', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Percentage: percentage,
                Index: index
            }),
        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, index);
        });
    },

    addDiscountCode: function(code, index = 0)  {

        app.hideAllTooltips();

        var self = this;

        fetch('/api/cart/adddiscountcode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Code: code,
                Index: index
            }),
        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, index);

            //console.log('eee');
            //window.location.reload();

            if (typeof self.$refs.placeOrderSummary !== 'undefined') {
                self.$refs.placeOrderSummary.reloadPayments();
            }

        });
    },
    sendRemoveDataLayer: (product, index = 0) => {

        fetch('/api/cart/datalayeriteminfo', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Code: product.code,
                Index: index,
                Quantity: product.quantity
            }),
        }).then(response => response.json()).then((item) => {
            
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ 'ecommerce': null });
            dataLayer.push({
                'event': 'remove_from_cart',
                'ecommerce': item
            });
        });

    },
    removeProductFromCart: (product, index = 0) => {
        fetch('/api/cart/addorupdate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': document.documentElement.lang,
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          Code: product.code,
          Quantity: product.quantity * -1,
          ConfigurationString: product.configurationString,
          PartsList : product.partsList,
          Index: index
        }),
      }).then(response => response.json()).then((cartData) => {
          app.assignCartData(cartData, index);
      });
    },
    moveProductFromCart: (product, index = 0) => {

        if (index === 1) {
            app.$refs.shoppinglistheaderclosebutton1.click();
            setTimeout(() => { app.$refs.shoppinglistheaderbutton.click(); }, 600);
        }
        else if (app.cart[index].products.length <= 1) {
            app.$refs.shoppinglistheaderclosebutton.click();
            setTimeout(() => { app.$refs.shoppinglistheaderbutton1.click(); }, 600);
        }

        fetch('/api/cart/copyproduct', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': document.documentElement.lang,
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Code: product.code,
                Quantity: product.quantity * 1,
                ConfigurationString: product.configurationString,
                PartsList: product.partsList,
                Index: 1 - index
            }),
        }).then(response => response.json()).then((cartData) => {
            app.assignCartData(cartData, 1 - index);


            if (index === 0) {

                fetch('/api/cart/addorupdate', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        Code: product.code,
                        Quantity: product.quantity * -1,
                        ConfigurationString: product.configurationString,
                        PartsList: product.partsList,
                        Index: index
                    }),
                }).then(response => response.json()).then((cartData2) => {
                    app.assignCartData(cartData2, index);
                });
            }

        });

    },
    toggleRemoveTooltip: (product) => {
      if (product.deleteTooltipOpen) {
        Vue.set(product, 'deleteTooltipOpen', false);
      } else {
        Vue.set(product, 'deleteTooltipOpen', true);
      }
    },

      toggleRemoveTooltip2: (product) => {
          if (product.deleteTooltipOpen2) {
              Vue.set(product, 'deleteTooltipOpen2', false);
          } else {
              Vue.set(product, 'deleteTooltipOpen2', true);
          }
      },

      updateCartLineQuantity: (index, product, value, input) => {
      const newValue = parseInt(value, 10);
      const oldValue = product.quantity;

      if (typeof newValue !== 'number') {
        input.value = oldValue;
        product.quantity = oldValue;
        return;
      }

      if (newValue < 1 || newValue > 20) {
        Vue.nextTick(() => {
          input.value = oldValue;
          product.quantity = oldValue;
        });
      } else {
        const iQuantityDiff = (newValue - product.quantity);
        product.quantity = newValue;

          app.addOrUpdateCart(product.code, product.displayname, iQuantityDiff, null, null, null, null, 0, 0, null, true, input, product.configurationString, null, index, null, product.partsList, null);
      }
    },
    incrementQuantity: (index, product, input) => {
      if (product.quantity < 20) {
        const newValue = product.quantity + 1;
        if (typeof input !== 'undefined') {
          input.value = newValue;
        }
        app.updateCartLineQuantity(index, product, newValue);
      }
    },
    decrementQuantity: (index, product, input) => {
      if (product.quantity >= 1) {
        const newValue = product.quantity - 1;
        if (typeof input !== 'undefined') {
          input.value = newValue;
        }
        app.updateCartLineQuantity(index, product, newValue);
      }
    },
    assignCartData: (cartData, index = 0) => {
        app.cart[index].cartInit = true;
        if (app.extranetPage !== 3) {
            app.extranetPage = 0;
        }
        if (cartData) {
            app.cart[index].totalProductCount = cartData.totalProductCount;
            app.cart[index].anywarrantyActive = cartData.anywarrantyActive;
            app.cart[index].products = cartData.items;
            app.cart[index].filteredProducts = app.cart[index].products.filter(function (product) { return product.articleCode.indexOf('10350GP') === -1 });
            app.cart[index].anyTruckHi = app.cart[index].filteredProducts.filter(function (product) { return product.truckHi === true }).length > 0;
            app.cart[index].anyTruckLo = app.cart[index].filteredProducts.filter(function (product) { return product.truckLo === true }).length > 0;
            app.cart[index].vat = cartData.vat;
            app.cart[index].vatExShipping = cartData.vatExShipping;
            app.cart[index].totalEco = cartData.totalEcoTax;
            app.cart[index].totalVat = cartData.totalVAT;
            app.cart[index].totalPrice = cartData.totalInclVAT;
            app.cart[index].toPayPrice = cartData.toPayInclVAT;
            app.cart[index].toPayInclVATUnformatted = cartData.toPayInclVATUnformatted;
            app.cart[index].oldTotalPrice = cartData.oldTotalInclVAT;
            app.cart[index].totalPriceExShipping = cartData.totalInclVATExShipping;
            app.cart[index].oldTotalPriceExShipping = cartData.oldTotalInclVATExShipping;
            app.cart[index].shipping = cartData.shipping;
            app.cart[index].oldShipping = cartData.oldShipping;
            app.cart[index].shopCredit = cartData.shopCredit;
            app.cart[index].shopCreditCouponCodes = cartData.shopCreditCouponCodes;
            app.cart[index].selectedShopCreditString = cartData.selectedShopCreditString;            
            app.cart[index].remainingShopCreditCouponCodes = cartData.remainingShopCreditCouponCodes;
            app.cart[index].giftCertificates = cartData.giftCertificates;
            app.cart[index].giftCertificateCouponCodes = cartData.giftCertificateCouponCodes;
            app.cart[index].selectedGiftCertificatesString = cartData.selectedGiftCertificatesString;
            app.cart[index].hasPromotionCode = cartData.hasPromotionCode;
            app.cart[index].noStock = cartData.noStock;
            app.cart[index].hasAllParcelService = cartData.hasAllParcelService;
            app.cart[index].hasAllGiftCertificates = cartData.hasAllGiftCertificates;
            app.cart[index].hasAnyAssemblyRequired = cartData.hasAnyAssemblyRequired;
            app.cart[index].hasAnyGiftCertificate = cartData.hasAnyGiftCertificate;
            app.cart[index].hasDeliveryService = cartData.hasDeliveryService;
            app.cart[index].hasDeliveryServicePlus = cartData.hasDeliveryServicePlus;
            app.cart[index].hasTruckService = cartData.hasTruckService;
            app.cart[index].hasWebShop = cartData.hasWebShop;
            app.cart[index].upgradeShipmentMethod = cartData.upgradeShipmentMethod;
            app.cart[index].giftCertificateViaPost = cartData.giftCertificateViaPost;
            app.cart[index].upgradeShipmentMethodAllowed = cartData.upgradeShipmentMethodAllowed;
            app.cart[index].createdMilliSeconds = cartData.createdMilliSeconds;
            app.cart[index].modifiedMilliSeconds = cartData.modifiedMilliSeconds;
            app.cart[index].maxFirstWeekAvailableText = cartData.maxFirstWeekAvailableText;
            app.cart[index].maxFirstWeekAvailableTextComment = cartData.maxFirstWeekAvailableTextComment;
            app.cart[index].maxFirstWeekAvailable = cartData.maxFirstWeekAvailable;
            app.cart[index].maxShowFirstWeekAvailable = cartData.maxShowFirstWeekAvailable;
            app.cart[index].downpaymentPercentage = cartData.downpaymentPercentage;
            app.cart[index].downpaymentAllowed = cartData.downpaymentAllowed;
            app.cart[index].downPaymentPayToDriverUnformatted = cartData.downPaymentPayToDriverUnformatted;
            app.cart[index].downPaymentPayToDriver = cartData.downPaymentPayToDriver;
            app.cart[index].downPaymentPayNowUnformatted = cartData.downPaymentPayNowUnformatted;
            app.cart[index].downPaymentPayNow = cartData.downPaymentPayNow;

            app.cart[index].quantityOrderDiscountMarketingBlock = cartData.quantityOrderDiscountMarketingBlock;
            app.cart[index].quantityItemDiscountMarketingBlock = cartData.quantityItemDiscountMarketingBlock;
            app.cart[index].itemDiscountMarketingBlock = cartData.itemDiscountMarketingBlock;
            app.cart[index].orderDiscountMarketingBlock = cartData.orderDiscountMarketingBlock;
            app.cart[index].freeShippingCostMarketingBlock = cartData.freeShippingCostMarketingBlock;
            app.cart[index].shippingCostDiscountMarketingBlock = cartData.shippingCostDiscountMarketingBlock;
            app.cart[index].couponMarketingBlock = cartData.couponMarketingBlock;
            app.cart[index].upgradeShipmentMethodMarketingBlock = cartData.upgradeShipmentMethodMarketingBlock;
            app.cart[index].giftCertificateViaPostMarketingBlock = cartData.giftCertificateViaPostMarketingBlock;
            app.cart[index].forcedUpgradeShipmentMethodMarketingBlock = cartData.forcedUpgradeShipmentMethodMarketingBlock;
            app.cart[index].staticMarketingBlock = cartData.staticMarketingBlock;
            app.cart[index].validationIssues = cartData.validationIssues;
      } else {

            app.cart[index].totalProductCount = 0;
            app.cart[index].anywarrantyActive = false;
            app.cart[index].products = [];
            app.cart[index].filteredProducts = [];
            app.cart[index].anyTruckHi = false;
            app.cart[index].anyTruckLo = false;
            app.cart[index].vat = [];
            app.cart[index].vatExShipping = [];
            app.cart[index].totalEco = '';
            app.cart[index].totalVat = '';
            app.cart[index].totalPrice = '';
            app.cart[index].toPayPrice = '';
            app.cart[index].toPayInclVATUnformatted = 0;
            app.cart[index].oldTotalPrice = '';
            app.cart[index].shipping = '';
            app.cart[index].oldShipping = '';
            app.cart[index].shopCredit = '';
            app.cart[index].shopCreditCouponCodes = '';
            app.cart[index].selectedShopCreditString = '';            
            app.cart[index].remainingShopCreditCouponCodes = '';
            app.cart[index].giftCertificates = '';
            app.cart[index].giftCertificateCouponCodes = '';
            app.cart[index].selectedGiftCertificatesString = '';           
            app.cart[index].totalPriceExShipping = '';
            app.cart[index].oldTotalPriceExShipping = '';
            app.cart[index].hasPromotionCode = false;
            app.cart[index].noStock = false;
            app.cart[index].hasAllParcelService = true;
            app.cart[index].hasAllGiftCertificates = false;
            app.cart[index].hasAnyAssemblyRequired = false;
            app.cart[index].hasAnyGiftCertificate = false;
            app.cart[index].hasDeliveryService = false;
            app.cart[index].hasDeliveryServicePlus = false;
            app.cart[index].hasTruckService = false;
            app.cart[index].hasWebShop = false;
            app.cart[index].upgradeShipmentMethod = '';
            app.cart[index].giftCertificateViaPost = false;
            app.cart[index].upgradeShipmentMethodAllowed = false;
            app.cart[index].createdMilliSeconds = 0;
            app.cart[index].modifiedMilliSeconds = 0;
            app.cart[index].maxFirstWeekAvailableText = '';
            app.cart[index].maxFirstWeekAvailableTextComment = '';
            app.cart[index].maxFirstWeekAvailable = 0;
            app.cart[index].maxShowFirstWeekAvailable = false;
            app.cart[index].downpaymentPercentage = 0;
            app.cart[index].downpaymentAllowed = false;
            app.cart[index].downPaymentPayToDriverUnformatted = 0;
            app.cart[index].downPaymentPayToDriver = '';
            app.cart[index].downPaymentPayNowUnformatted = 0;
            app.cart[index].downPaymentPayNow = '';

            app.cart[index].quantityOrderDiscountMarketingBlock = [];
            app.cart[index].quantityItemDiscountMarketingBlock = [];
            app.cart[index].itemDiscountMarketingBlock = [];
            app.cart[index].orderDiscountMarketingBlock = [];
            app.cart[index].freeShippingCostMarketingBlock = [];
            app.cart[index].shippingCostDiscountMarketingBlock = [];
            app.cart[index].couponMarketingBlock = [];
            app.cart[index].upgradeShipmentMethodMarketingBlock = [];
            app.cart[index].giftCertificateViaPostMarketingBlock = [];
            app.cart[index].forcedUpgradeShipmentMethodMarketingBlock = [];
            app.cart[index].staticMarketingBlock = [];
            app.cart[index].validationIssues = [];
        }


        if (app.cart[index].createdMilliSeconds > 0 && app.cart[index].modifiedMilliSeconds > 0 && app.cart[index].totalProductCount > 0) {

            if (index === 0) {

                if (app.shoppingCartWarningTime > 0) {
                    var shoppingCartCreatedMinutes = (Date.now() - app.cart[index].createdMilliSeconds) / 60000.0;
                    var shoppingCartModifiedAgeMinutes = (Date.now() - app.cart[index].modifiedMilliSeconds) / 60000.0;
                    var shoppingCartPopupAgeMinutes = 0;

                    var shoppingCartPopupms = docCookies.getItem('openShoppingCartWarningPopup');
                    if (shoppingCartPopupms > 0) {
                        shoppingCartPopupAgeMinutes = (Date.now() - shoppingCartPopupms) / 60000.0;
                    }
                    //console.log(shoppingCartPopupAgeMinutes);
                    //console.log(shoppingCartCreatedMinutes);
                    //console.log(shoppingCartModifiedAgeMinutes);

                    if (shoppingCartPopupAgeMinutes === 0 || shoppingCartPopupAgeMinutes > shoppingCartCreatedMinutes) { // minutes

                        if (shoppingCartModifiedAgeMinutes > app.shoppingCartWarningTime) {
                            app.showShoppingCartWarningPopup();
                        }
                    }
                }
            }
            else {

                if (app.favoritesWarningTime > 0) {
                    var favoritesCreatedMinutes = (Date.now() - app.cart[index].createdMilliSeconds) / 60000.0;
                    var favoritesModifiedAgeMinutes = (Date.now() - app.cart[index].modifiedMilliSeconds) / 60000.0;
                    var favoritesPopupAgeMinutes = 0;

                    var favoritesPopupms = docCookies.getItem('openFavoritesWarningPopup');
                    if (favoritesPopupms > 0) {
                        favoritesPopupAgeMinutes = (Date.now() - favoritesPopupms) / 60000.0;
                    }
                    if (favoritesPopupAgeMinutes === 0 || favoritesPopupAgeMinutes > favoritesCreatedMinutes) { // minutes

                        if (favoritesModifiedAgeMinutes > app.favoritesWarningTime) {
                            app.showFavoritesWarningPopup();
                        }
                    }
                }
            }

        }
    },
    showAccountDropdownView: () => {

        const accountdropdownModal = new Modal(document.querySelector('#accountdropdown-modal'));

        accountdropdownModal.open();

    },
    showCartAccountDialog: () => {
      app.showCartAccount = !app.showCartAccount;
    },
    toggleCartSaved: () => {
      app.showCartSaved = !app.showCartSaved;
    },
    showCartEmailDialog: () => {
        app.showCartEmail = !app.showCartEmail;
    },
    cartSendEmail: (e, index = 0) => {

        app.showCartEmail = false;

        var cartEmail = index === 0 ? e.target.elements.CartEmail.value : e.target.elements.CartEmail1.value;

        e.preventDefault();
        if (cartEmail !== '') {
            fetch('/api/cart/sendemail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    Email: cartEmail,
                    Index: index
                }),
            }).then((response) => {
            });
        }
    },

    cartLogin: (e, index = 0) => {
        e.preventDefault();

        var cartLoginEmail = index === 0 ? e.target.elements.CartLoginEmail.value : e.target.elements.CartLoginEmail1.value;
        var cartLoginPassword = index === 0 ? e.target.elements.CartLoginPassword.value : e.target.elements.CartLoginPassword1.value;

        if (cartLoginEmail !== '' && cartLoginPassword !== '') {
          fetch('/api/account/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': document.documentElement.lang,
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
              Email: cartLoginEmail,
              Password: cartLoginPassword,
            RememberMe: true,
          }),
        }).then(response => response.json()).then((loginResponse) => {
          if (!loginResponse.loginSucceeded) {
            app.cartLoginErrorMessage = loginResponse.errorMessage;
          } else {
            app.showCartAccount = false;
            app.toggleCartSaved();

            app.getLoggedInUser();
          }
        });
      }
    },
    accountLogin: (e) => {
        e.preventDefault();
        if (e.target.elements.DropdownLoginEmail.value !== '' && e.target.elements.DropdownLoginPassword.value !== '') {
            fetch('/api/account/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    Email: e.target.elements.DropdownLoginEmail.value,
                    Password: e.target.elements.DropdownLoginPassword.value,
                    RememberMe: true,
                }),
            }).then(response => response.json()).then((loginResponse) => {
                if (!loginResponse.loginSucceeded) {
                    app.cartLoginErrorMessage = loginResponse.errorMessage;
                } else {
                    app.showCartAccount = false;
                    app.toggleCartSaved();

                    if (e.target.elements.redirectUrl.value !== '') {
                        window.location.href = e.target.elements.redirectUrl.value;
                    } else {
                        window.location.reload();
                    }
                }
            });
        }
    },
    facebookLogin: (redirect) => {
      FB.login((response) => {
        app.facebookLoginCallback(response, redirect);
      }, { scope: 'public_profile,email' });
    },
    facebookLoginCallback: (fbResponse, redirect) => {
      if (fbResponse.status === 'connected') {
          fetch('/api/account/facebooklogin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': document.documentElement.lang,
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            accessToken: fbResponse.authResponse.accessToken,
            redirect,
          }),
        }).then(response => response.json()).then((loginResponse) => {
          if (loginResponse.loginSucceeded) {
            app.showCartAccount = false;
            app.showCartSaved = true;
          } else {
            app.cartLoginErrorMessage = loginResponse.errorMessage;
          }

          if (redirect && loginResponse.redirectUrl) {
              window.location.href = loginResponse.redirectUrl;
          } else if (loginResponse.loginSucceeded) {
              app.getLoggedInUser();
          }
        });
      }
    },
    printCart: () => {
      window.print();
    },


    toggleSearch: () => {
      app.searchOpen = !app.searchOpen;

      const headerTopMobile = document.querySelector('.header__top--mobile');
      if (headerTopMobile) {

          const headerTopMobileHasHide = headerTopMobile.classList.contains('header__top--mobile--hide')

          if (app.searchOpen ) {
              if (!headerTopMobileHasHide) {
                  headerTopMobile.classList.add('header__top--mobile--hide');
              }

          } else if (headerTopMobileHasHide) {

              headerTopMobile.classList.remove('header__top--mobile--hide');
          }
      }

      // If mobile menu is open, close mobile menu
      const oMobileMenu = document.querySelector('.js-mobile-navigation');

      if (oMobileMenu.classList.contains('active')) {
        const oMenuToggle = document.querySelector('.js-toggle-menu');
        oMenuToggle.click();
      }
    },
    toggleAutocomplete: (e) => {
      if (e.target.value.length >= 3) {
        app.autocompleteOpen = !app.autocompleteOpen;
      }
    },
    openAutosuggestLink: (query) => {
      // window.location.href = e.target.getAttribute('href');
      app.searchTerm = query;

      Vue.nextTick(() => {
        if (typeof app.$refs.searchForm !== 'undefined') {
          app.$refs.searchForm.submit();
        } else {
          app.$refs.headerSearchForm.submit();
        }
      });
    },
    autocomplete: (e) => {
      if (e.target.value.length >= 3) {
        app.autocompleteOpen = true;

          fetch('/api/search/autocomplete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': document.documentElement.lang,
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            query: `${app.searchTerm}`,
          }),
        }).then(response => response.json()).then((autocompleteResponse) => {
          app.autocompleteSuggestions = autocompleteResponse.hits;
        });
      } else {
        app.autocompleteOpen = false;
      }
    },
    onSearchArrowDown: () => {
      if (app.searchAutocompleteIndex < app.autocompleteSuggestions.length - 1) {
        app.searchAutocompleteIndex += 1;
      }
    },
    onSearchArrowUp: () => {
      if (app.searchAutocompleteIndex > 0) {
        app.searchAutocompleteIndex -= 1;
      }
    },
    onSearchEnter: () => {
      //
      //     window.location.href = app.autocompleteSuggestions[app.searchAutocompleteIndex].url;
      // }
      if (app.searchAutocompleteIndex >= 0) {
        app.openAutosuggestLink(app.autocompleteSuggestions[app.searchAutocompleteIndex].query);
      }
    },

    focusSearch: (e) => {
      e.currentTarget.previousElementSibling.focus();
    },

    /*handleOverviewPost: (e) => {
        if (e.submitter.id === "overviewNewsletter" ) {
            app.subscribeNewsletter(e);
        }
        else if (e.submitter.id === "overviewFindDealer") {
            app.overviewFindDealer(e);
        }
        e.preventDefault();
    },*/

    htmlDecode : (input) => {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    },

    overviewFindDealer: (e) => {

        var overviewzipcodeurl = '';

        var zipCode = '';

        if (e.submitter.id === "overviewFindDealer4") {
            let zipCodeElement = document.getElementById('FindDealerBlockZipCode4');
            if (zipCodeElement !== null && zipCodeElement.value.length > 0) {
                zipCode = zipCodeElement.value;
            }
        }
        else {
            let zipCodeElement = document.getElementById('FindDealerBlockZipCode');
            if (zipCodeElement !== null && zipCodeElement.value.length > 0) {
                zipCode = zipCodeElement.value;
            }
        }

        let n1 = document.getElementById('overviewzipcodeurl');
        if (n1 !== null && n1.value.length > 0 && zipCode.length > 0) {
            overviewzipcodeurl = n1.value;

            window.location.href = overviewzipcodeurl + "?zipcode=" + escape(zipCode);
        }
    },

    subscribeNewsletter: (e, showSuccessModal = true) => {
      const email = e.target.elements.Email.value;
        if (email !== null && email.length > 0) {

            var requestedText = '';

            let n1 = document.getElementById('newsletterrequestedtext');
            if (n1 !== null && n1.value.length > 0) {
                requestedText = n1.value;
            }
            let n2 = document.getElementById('newsletterrequestedtextfooter');
            if (n2 !== null && n2.value.length > 0) {
                requestedText = n2.value;
            }
            let n3 = document.getElementById('overviewnewsletterrequestedtext');
            if (n3 !== null && n3.value.length > 0) {
                requestedText = n3.value;
            }

            var firstName = '';

            let firstNameElement = document.getElementById('NewsLetterSignupBlockFirstName');
            if (firstNameElement !== null && firstNameElement.value.length > 0) {
                firstName = firstNameElement.value;
            }

            let firstNameElement2 = document.getElementById('newsletter-firstname');
            if (firstNameElement2 !== null && firstNameElement2.value.length > 0) {
                firstName = firstNameElement2.value;
            }

            let buttonElement = document.getElementById('newsletterfooterblock');
            if (buttonElement !== null) {
                buttonElement.innerHTML = "<p style='font-weight:bold;'>" + requestedText + "</p>";
            }

            let buttonElement2 = document.getElementById('newslettersignupblock');
            if (buttonElement2 !== null) {
                buttonElement2.innerHTML = "<p style='font-weight:bold;'>" + requestedText + "</p>";
            }

            let buttonElement3 = document.getElementById('newslettersignupblock2');
            if (buttonElement3 !== null) {
                buttonElement3.innerHTML = "<p style='font-weight:bold;'>" + requestedText + "</p>";
            }

            const lastName = '';

            var spotleraction = "";
            if (e.target.elements.spotleraction && e.target.elements.spotleraction.value) {
                spotleraction = e.target.elements.spotleraction.value;
            }

            var newsletterSuccessMessage = "";
            if (e.target.elements.newsletterSuccessMessage && e.target.elements.newsletterSuccessMessage.value) {
                newsletterSuccessMessage = app.htmlDecode(e.target.elements.newsletterSuccessMessage.value);
            }

            if (e.target.checkValidity()) {

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'newsletter_submit',
                    'userdata': {
                        'email': email,
                        'address': {
                            'first_name': firstName,
                            'last_name': lastName
                        }
                    }
                });

                fetch('/api/newsletter/subscribe', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        email: `${email}`,
                        firstName: `${firstName}`,
                        lastName: `${lastName}`,
                        spotleraction: `${spotleraction}`,
                    }),
                }).then(response => response.json()).then((newsletterResponse) => {
                    app.newsletterSubscribeSuccess = newsletterResponse.success;
                    app.newsletterSubscribeFeedback = newsletterResponse.feedback;
                    app.newsletterSuccessMessage = newsletterSuccessMessage;

                    localStorage.setItem('newsletterSubscribeSuccess', newsletterResponse.success);
                    localStorage.setItem('newsletterSubscribeFeedback', newsletterResponse.feedback);
                    localStorage.setItem('newsletterSuccessMessage', newsletterSuccessMessage);

                    if (showSuccessModal) {
                        const newsletterModal = new Modal(document.querySelector('.js-newsletter-modal'));

                        newsletterModal.open();
                    }
                });
            }
        }
    },
    handleViewportChange() {
      if (mq.matches) {
          this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    lookbookSubmit: (e) => {
      if (app.lookbookNewsletterSignup) {
        app.subscribeNewsletter(e, false);
      }
    },
    historyBack() {
      window.history.back();
    },
    playHeroVideo(e) {
      this.$refs.heroVideo.play();
      this.heroVideoPlaying = true;
    },
    playHeroVideoMobile(e) {
      this.$refs.heroVideoMobile.play();
      this.heroVideoMobilePlaying = true;
    },
    flowboxtagclick(tag, key, locale) {

        this.activeFlowboxTag = tag;

        window.flowbox('update', {
            key: key,
            tags: [ tag ],
            tagsOperator: 'any'
        });
    },
    showStickyHeader(show) {

        if (document.querySelectorAll('.js-sticky-header').length) {
            var navBar = document.querySelector('.js-sticky-header');

            const stickyClass = 'header--sticky';
            if (show) {
                if (!navBar.classList.contains(stickyClass)) {
                    navBar.classList.add(stickyClass);
                    let navBarHeight = navBar.offsetHeight;
                    website.body.style.paddingTop = `${navBarHeight}px`;
                }
            } else {
                if (navBar.classList.contains(stickyClass)) {
                    navBar.classList.remove(stickyClass);
                    website.body.style.paddingTop = null;
                }
            }
        }
    }
  },
}).$mount('.js-app');
